const env = {
  // LLM Configuration
  REACT_APP_DEFAULT_LLM_SERVICE: process.env.REACT_APP_DEFAULT_LLM_SERVICE || 'openai',
  REACT_APP_OPENAI_CACHE_ENABLED: process.env.REACT_APP_OPENAI_CACHE_ENABLED || 'true',
  REACT_APP_OPENAI_CACHE_TTL: process.env.REACT_APP_OPENAI_CACHE_TTL || '86400',

  // API Configuration
  REACT_APP_FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL || process.env.FRONTEND_URL || 'http://localhost:3003',
  // Use explicit API URL from environment, with fallback to localhost:8000
  REACT_APP_API_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',

  // OAuth Configuration
  REACT_APP_GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  REACT_APP_GOOGLE_REDIRECT_URI: process.env.REACT_APP_GOOGLE_REDIRECT_URI,
};

export default env;
